module.exports = __webpack_public_path__ + "img/icon-money-gold.a11081b1.svg";